module.exports = __webpack_public_path__ + "static/media/seguros-mundial-survey-agent.09ae418b.svg";